export interface IFormMaster {
  id: number;
  title: string;
  description: string;
  nickname: string;
  typeId?: number;
  campaignTypeId?: number;
  schema: string;
  formId: string;
  itemIds?: string;
  createdByName: string;
  updatedByName: string;
  createdOn: Date;
  updatedOn?: Date;
  isStripeEmbedInCustomJotForm?: boolean;
  disabledFieldState?: { [key: string]: boolean };
  formTemplateMasterId?: number | null;
  items: IFormLinkedItem[];
}
export interface IFormLinkedItem {
id:number;
displayId:string;
displayName:string;
campaignId:number;
campaignDisplayName:string;
}

export interface ITemplateFormMaster {
  id: number;
  formId: string;
  title: string;
  nickname: string;
  schema: string;
  description: string;
  verticals: string;
  createdByName: string;
  updatedByName: string;
  createdOn: Date;
  updatedOn?: Date;
  formCategoryType:number;
  disabledFieldState: { [key: string]: boolean };
}

export interface IFormListingDto {
  id: number;
  title: string;
  formId: string;
  nickname: string;
  isTemplateForm: boolean;
}

export interface FormSubmitDto {
  formId: number;
  itemId?: number;
  communityId: number;
  isOnlinePayment: boolean;
  formValues: { [key: string]: any };
  paymentMethod?: number;
  price?: number;
  isVolunteer: boolean;
  paymentIntentId?: string;
  volunteerShiftId?: number;
  numberOfTickets?: number | null;
  requireApplicantApproval?: boolean;
  discountSelections?: TicketDiscountSelectionDto[]
}
export interface TicketDiscountSelectionDto{
  discountGroupId?: number;
  isFreeTicket?:boolean;
  title?:string;
  price?:number;
  quantity?:number;
}
export interface IPaymentIntentRequest{
  amount: number;
  email: string;
  name: string;
  phone: string;
  postalCode: string;
  paymentMethod: string | null;
  metaData: { [key: string]: string };
  formSubmitDtoJson?: string;
  descriptor?: string;
  donorId: number | null;
}

export interface IPaymentIntentResponse{
  id: string;
  clientSecret: string;
}

export interface IPaymentPortalDetails {
  activityLogId: number;
  firstName: string;
  lastName: string;
  email: string;
  itemDisplayName: string;
  campaignDisplayName: string;
  campaignType: number;
  communityDisplayName: string;
  approvedPaymentAmount: number | null;
  applicationStatus: number | null;
  paymentStatus: number | null;
  paymentDate?: string | null;
  canPay: boolean;
  phone?: string;
  postalCode?: string;
  itemId?: number;
  communityId?: number;
  formMasterId?: number;
  campaignTypeId?: number;
  itemTypeId?: number;
  descriptor?: string;
}

export interface IApplicationPaymentDetails {
  applicationId: string;
  vendorType: string;
  applicationName: string;
  submitterName: string;
  communityName: string;
  amount: number;
  email: string;
  phone?: string;
  postalCode?: string;
  itemId?: number;
  communityId?: number;
  formMasterId?: number;
  campaignTypeId?: number;
  itemTypeId?: number;
  descriptor?: string;
}
